import React, { useState } from 'react';
import { Container, Nav, Row, Col, Button, Accordion, ListGroup, OverlayTrigger, Tooltip, Tabs, Tab } from 'react-bootstrap';

export default function About(){
  const [activeSection, setActiveSection] = useState('who');
  const [activeTab, setActiveTab] = useState('who');
  const [expandedBeliefs, setExpandedBeliefs] = useState({});

  const beliefs = [
    {
      title: 'The Bible',
      content: 'We believe all 66 books of Scripture are inspired by God and therefore, are inerrant in their original documents. They contain the complete and sufficient revelation of God\'s will and plan for salvation and are the final authority for faith and life.\n\nVerses: 2 Timothy 3:16-17; 2 Peter 1:21; John 16:13-14; 17:17; Numbers 23:19; Psalm 12:6; Hebrews 4:12, 6:18; Matthew 5:18, 24:35; Mark 13:31; John 20:31'
    },
    {
      title: 'God (Trinity)',
      content: 'We believe in One God who created and sustains all things. God has eternally existed in three Persons; The Father, The Son, and The Holy Spirit. They are equal and holy in all divine attributes. The Persons of the Godhead perform distinct and harmonious roles in creation, providence, and redemption.\n\nVerses: Deut 6:4; Isa 45:7; Mk 12:29; Gen 1:1; Mat 28:19; Mat 3:16; 2 Corinthians 13:14; John 15:26, 16:3; Phil 2; John 14:6; Mat 28:18; Acts 5:3-4; Jn 1:14; Heb 9:13,14; I Pet 1:2'
    },
    {
      title: 'God the Father',
      content: 'We believe that God the Father is the eternal, all-powerful Creator and sustainer of the universe who has ordered all things according to His perfect will and for His glory and has sent His Son, Jesus Christ, into this world to redeem sinful man. In addition to His role as Father within the godhead, God the Father adopts as His children all who come to Him in Christ therefore, all believers have the right to address Him as Abba Father.\n\nVerses: John 1:12; Romans 8:14-15; 11:36; 1 Corinthians 8:6; 2 Corinthians 6:18; Galatians 4:5; Ephesians 1:5-6, 11; Eph 4:6; Ephesians 3:9; John 15:1,8'
    },
    {
      title: 'God the Son',
      content: 'We believe that God the Son, the Lord Jesus Christ, is an eternal person of the Godhead who was sent by the Father into this world. He was born as the Messiah to the virgin Mary conceived by the Holy Spirit. He was born without sin and lived a completely sinless life. He is both truly Man and truly God. Jesus willingly suffered and died on a cross as a substitute for mankind satisfying the penalty for their sin, was buried, and rose from the dead on the third day. He ascended into heaven, and is seated at the right hand of God the Father as our High Priest and Advocate. He will return from heaven in the future, visible, in person, fulfilling all of the prophecies about his life.\n\nVerses: Gal 4:4; John 1:1,2; John 1:14; Isa 7:14; Matt 1:20,21; 1 Jn 3:5; 2 Cor 5:21; 1 Pet 2:22; Heb 4:15; Luke 2:52; Phil 2:6-8; 1 Tim. 2:5; Heb. 2:5; 1 Cor 15:3-4; Heb. 1:3; Rom 8:34; 1 Jn 2:1; Acts 1:9-11; Rev 1:7'
    },
    {
      title: 'God the Holy Spirit',
      content: 'We believe in the Person of God the Holy Spirit, co-equal with God the Father and God the Son. He glorifies the Lord Jesus and implements Christ\'s work of salvation. He works in this world to convict man of sin, regenerate believers unto salvation, sanctify believers for Christ-like living, and preserve them through eternity. Through the indwelling and filling of the Spirit believers are empowered for godly living and service. The Holy Spirit gives spiritual gifts for the purpose of building up the church.\n\nVerses: Matt 28:19; John 3:5-7; Acts 1:8; John 14:16-17; John 15:26; Eph 1:13; John 16:13-14; 1 Cor 12:4-13; Rom 8:26; 2 Cor 3:18; Gal 5:22-23; Heb 10:15-16; Heb 2:4'
    },
    {
      title: 'Man',
      content: 'We believe that God created man in His own image, without sin, as male and female. God created man to glorify Himself, to be the stewards of this Earth, and to enjoy perfect fellowship with both God and fellow man. As a result of the fall of mankind all humans are sinners by their nature and choice and are spiritually dead. The result of this is separation from God both now and for all eternity. The only exception being the Lord Jesus Christ who is completely perfect and without sin. We further believe that if man repents of his sin and trusts in Jesus Christ as Savior he will then be saved and brought into eternal fellowship with God. Those, however, who do not repent and trust in Christ before death will eternally abide in hell, separated from God, and will suffer His just wrath upon them as a result of their sins.\n\nVerses: Gen 1:27; Gen 1:31; Rev 21:3-4; 1 Peter 2:22; Col 1:20-21; 2 Cor 5:21; Eph 2:1; John 3:36; Rom 2:5; Rev 20:15; Rom 5:1'
    },
    {
      title: 'Salvation',
      content: 'We believe that Salvation is a secure gift that cannot be lost which God offers to all humans by His grace. It is received through repentance and personally trusting Jesus\' all-sufficient sacrificial death and resurrection through which God forgives our sins. We, therefore, are saved from the penalty of sin, which is the eternal separation and wrath of God. Once saved, a believer lives in an eternally restored relationship with God as a part of His family. We believe that Christians are called to a life of separation unto Christ, one that exhibits obedience and pursues holiness as we seek to be conformed to His image.\n\nVerses: Rom 8:35; John 10:27-30; Heb 7:25; Eph. 2:8-10; John 1:12; Eph. 1:7; 1 Peter 1:18-19; 1 Cor 15:3-4; Rom 6:8; Rom 10:9; Rom 5:18; 1 Cor 6:11; Acts 20:21; Acts 3:19'
    },
    {
      title: 'The Church',
      content: 'We believe that all those who trust in Jesus Christ as Savior are brought into the universal church, the Body of Christ, at the point of salvation. A local congregation is a small part of that greater body and is self-governing, its head being Christ who leads the church through a group of elders. We believe that the church\'s essential functions include teaching, fellowship, breaking of bread, and prayer as well as the ordinance of baptism. The church is to teach the Word of God, have corporate worship, build one another up through the use of spiritual gifts, submit to godly leadership, be accountable to each other, and engage in local and world evangelization and discipleship.\n\nVerses: Matthew 28:19-20; Acts 2:41-42; Acts 20:28; Rom 12:5; Eph 1:22-23; 1 Cor 12:12-27; Col 3:14-15; Eph 4:15-16; Heb 13:7; Col 4:16; Eph 5:23-25; 1 Peter 5:1-3; Acts 14:23; Eph 5:19-21'
    },
    {
      title: 'The Return of Christ',
      content: 'We believe in Christ\'s imminent return and rapture of the church after which, at the end of a seven year tribulation period, Christ will return with power and great glory to set up the millennial kingdom on earth. We believe that the final judgment of all who have rejected Christ throughout history will follow the millennial kingdom and at that time they will face condemnation to an everlasting conscious punishment. We also believe that all Christians will be resurrected bodily to an eternal blessedness with the Lord in the new heaven and the new earth.\n\nVerses: John 14:1-3; 1 Corinthians 15:51-52; 1 Thessalonians 4:13-18; Titus 2:11-14; Daniel 9:27; Revelation 6:1-19:21; 20:1-3; 11-15; Matthew 24:15-25:46; Revelation 21:1-3'
    }
  ];

  const toggleBelief = (index) => {
    setExpandedBeliefs(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const expandAll = () => {
    const allExpanded = {};
    beliefs.forEach((_, index) => {
      allExpanded[index] = true;
    });
    setExpandedBeliefs(allExpanded);
  };

  const collapseAll = () => {
    setExpandedBeliefs({});
  };

  return (
    <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
        <h1 className="mb-4 mb-md-5 fw-bold text-center" style={{ fontSize: '3.425rem', paddingTop: 0, color: '#c53607f5' }}>About Us</h1>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-5 nav-tabs-custom justify-content-center" style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '0', fontSize: '1.3rem' }}>
        <Tab eventKey="who" title="Who we are" tabClassName="fw-bold">
          <Row className="justify-content-center my-5">
            <Col xs={12} md={11} lg={10}>
              <p style={{ fontSize: '1.4rem', lineHeight: '2', marginBottom: '0' }}>We are Northwest Bible Fellowship: A group of born again believers in the <strong>northwest</strong> side of Pune that strives to follow the <strong>Bible</strong> in all that we do as we <strong>fellowship</strong> together with one heart to glorify the Lord! <br />
              We started meeting together as a church in January 2024.<br /> We are a community that knows that we need God for our existence and we need each other to walk this life well. <br />
              If life is overwhelming sometimes and you feel alone, please know that you are welcome here.<br /> We would love to meet you. <br />
              </p>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="why" title="Why are we here" tabClassName="fw-bold">
          <Row className="justify-content-center my-5">
            <Col xs={12} md={11} lg={10}>
              <div className="mb-5">
                <p className="fw-semibold mb-4" style={{ fontSize: '1.8rem' }}>Our Vision:</p>
                <ul style={{ fontSize: '1.35rem', lineHeight: '2', marginBottom: '0', textAlign: 'left', listStyle: 'none', paddingLeft: '0' }}>
                  <li>To reach the northwest side of Pune with the Gospel of Christ through the establishment of a strong and healthy Bible believing fellowship of disciples of Christ who shine as lights that bring glory to God.</li>
                </ul>
              </div>
              <div>
                <p className="fw-semibold mb-4" style={{ fontSize: '1.8rem' }}>Our Mission:</p>
                <ul style={{ fontSize: '1.35rem', lineHeight: '2', marginBottom: '0', textAlign: 'left', listStyle: 'none', paddingLeft: '0' }}>
                  <li>To be a Biblically-grounded, Christ-centered, Spirit-empowered fellowship of believers, who gather regularly to worship God, grow in grace, care for one another, and reach out to the lost with the gospel.</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="believe" title="What we believe" tabClassName="fw-bold" style={{ fontSize: '1.1rem', color: '#78b8d4' }}>
          <Row className="justify-content-center my-5">
            <Col xs={12} md={11} lg={10}>
              <div>
              <Row className="align-items-center mb-4">
                <Col xs={12} md={6} className="text-center mb-3 mb-md-0">
                  <p className="fs-5 fw-semibold mb-0" style={{ color: '#1a3a44' }}>
                    Statement of Faith
                  </p>
                </Col>
                <Col xs={12} md={6} className="text-end">
                  <div className="d-flex gap-2 justify-content-end">
                    <Button style={{ background: '#1a3a44', borderColor: '#1a3a44', fontSize: '0.75rem' }} size="sm" onClick={expandAll} className="fw-semibold">
                      Expand All
                    </Button>
                    <Button style={{ background: '#e8943a', borderColor: '#e8943a', fontSize: '0.75rem' }} size="sm" onClick={collapseAll} className="fw-semibold">
                      Collapse All
                    </Button>
                  </div>
                </Col>
              </Row>
              {beliefs.map((belief, index) => (
                <Row key={index} className="justify-content-center">
                  <Col xs={12}>
                    <Accordion className="accordion-custom" activeKey={expandedBeliefs[index] ? String(index) : null}>
                      <Accordion.Item eventKey={String(index)} onClick={() => toggleBelief(index)} style={{ border: 'none', marginBottom: '0.75rem', boxShadow: '0 2px 6px rgba(0,0,0,0.08)', borderRadius: '8px', overflow: 'hidden', borderLeft: `6px solid ${index % 2 === 0 ? '#0d6efd' : '#6f42c1'}`, backgroundColor: 'transparent' }}>
                        <Accordion.Header style={{ backgroundColor: 'transparent', padding: '0.8rem 1rem', fontWeight: '700', fontSize: '1.25rem' }}>
                          <span style={{ color: index % 2 === 0 ? '#0d6efd' : '#6f42c1' }}>
                            {belief.title}
                          </span>
                        </Accordion.Header>
                        <Accordion.Body style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
                          <p style={{ marginBottom: '0.8rem', marginTop: 0, paddingLeft: '0', paddingRight: '0', lineHeight: '1.6', fontSize: '1.25rem', color: '#333', textAlign: 'left' }}>
                            {belief.content.split('\n\nVerses:')[0]}
                          </p>
                          <div style={{ backgroundColor: 'transparent', padding: '0.8rem 1rem', borderRadius: '4px', margin: '0' }}>
                            <strong style={{ color: index % 2 === 0 ? '#0d6efd' : '#6f42c1', fontSize: '1.1rem' }}>Verses:</strong>
                            <div style={{ fontSize: '1rem', color: '#555', lineHeight: '1.4', marginTop: '0.3rem', textAlign: 'center' }}>
                              {belief.content.split('\n\nVerses: ')[1]}
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>
              ))}
                  </div>
            </Col>
          </Row>
        </Tab>
      </Tabs>

      {/* Original Pills Navigation - kept for reference */}
      <Nav className="justify-content-center mb-5 gap-3 flex-wrap d-none" variant="pills">
        <Nav.Item>
          <OverlayTrigger overlay={<Tooltip>Learn about who we are</Tooltip>}>
            <Nav.Link active={activeSection === 'who'} onClick={() => setActiveSection('who')} className="fw-semibold">
              Who we are
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
        <Nav.Item>
          <OverlayTrigger overlay={<Tooltip>Our vision and mission</Tooltip>}>
            <Nav.Link active={activeSection === 'why'} onClick={() => setActiveSection('why')} className="fw-semibold">
              Why are we here
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
        <Nav.Item>
          <OverlayTrigger overlay={<Tooltip>Our core doctrinal beliefs</Tooltip>}>
            <Nav.Link active={activeSection === 'believe'} onClick={() => setActiveSection('believe')} className="fw-semibold">
              What we believe
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
      </Nav>

      {activeSection === 'who' && (
        <div id="who-we-are" className="text-start d-none">
          

        <div className="p-4 rounded" style={{ background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.05), rgba(232, 148, 58, 0.05))', borderLeft: '5px solid #0d6efd' }}>
          <p className="fs-5">We are Northwest Bible Fellowship: A church in the <strong>northwest</strong> side of Pune that strives to follow the <strong>Bible</strong> in all that we do as we <strong>fellowship</strong> together with one heart to glorify the Lord! <br />
          We started meeting together as a church in January 2024.<br /> We are a community that knows that we need God for our existence and we need each other to walk this life well. <br />
          If life is overwhelming sometimes and you feel alone, please know that you are welcome here.<br /> We would love to meet you. <br />
          </p>
        </div>
        <div className="mt-4">
          <Button href="#contact" size="lg" style={{ background: 'linear-gradient(180deg, rgba(250, 163, 150, 0.95), #c53607f5)', border: 'none' }}>
            Plan a visit
          </Button>
        </div>
       
        </div>
        
      )}

      {activeSection === 'why' && (
        <div id="why-we-exist" className="text-start">
          <div className="p-4 rounded mb-4" style={{ background: 'linear-gradient(135deg, rgba(25, 135, 84, 0.05), rgba(232, 148, 58, 0.05))', borderLeft: '5px solid #198754' }}>
            <p className="fs-5 fw-semibold mb-3">Our Vision:</p>
            <ul className="fs-5 mb-0">
              <li>To reach the northwest side of Pune with the Gospel of Christ through the establishment of a strong and healthy Bible believing fellowship of disciples of Christ who shine as lights that bring glory to God.</li>
            </ul>
          </div>

          <div className="p-4 rounded" style={{ background: 'linear-gradient(135deg, rgba(111, 66, 193, 0.05), rgba(232, 148, 58, 0.05))', borderLeft: '5px solid #6f42c1' }}>
            <p className="fs-5 fw-semibold mb-3">Our Mission:</p>
            <ul className="fs-5 mb-0">
              <li>To be a community of Bible believing disciples of Christ who engage with each other and the local community</li>
              <li>To magnify and honor Christ with our lives</li>
              <li>To live life together based on the teachings of Scripture.</li>
              <li>To proclaim the Good News of salvation through faith in Christ Jesus to friends, family, and neighbors as the Lord gives us opportunity to do so.</li>
              <li>To be a blessing to our community and fellow residents of the northwest side of Pune</li>
            </ul>
          </div>
        </div>
      )}

      {activeSection === 'believe' && (
        <div id="what-we-believe">
          <Accordion defaultActiveKey={null} className="shadow-sm">
            {beliefs.map((belief, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header className="fw-bold" style={{ backgroundColor: index % 2 === 0 ? '#f0f6ff' : '#f5f0ff' }}>
                  <span style={{ color: index % 2 === 0 ? '#0d6efd' : '#6f42c1' }}>●</span> {belief.title}
                </Accordion.Header>
                <Accordion.Body>
                  <p style={{lineHeight: '1.6', color: '#333' }}>
                    {belief.content.split('\n\nVerses:')[0]}
                  </p>
                  <ListGroup className="mt-3">
                    <ListGroup.Item className="border-0" style={{ background: 'linear-gradient(90deg, rgba(13, 110, 253, 0.1), transparent)', borderLeft: '4px solid #0d6efd' }}>
                      <strong>Verses:</strong> {belief.content.split('\n\nVerses: ')[1]}
                    </ListGroup.Item>
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}
      </div>
    </Container>
  );
}
